import React from 'react'

const SquareCard = ({ title = "", points = [], isCurved = false }) => {

    return (
        <div className="w-full">
            <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center mb-8 lg:mb-12">
                {title}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 justify-center items-center">
                {
                    points.map((pointDetails, index) => {
                        const isFirst = index === 0;
                        const isLast = index === points.length - 1;
                        const curvedClass = (isCurved ? ((isFirst ? "md:rounded-bl-[6.5rem] " : (isLast ? "md:rounded-br-[6.5rem]" : ""))) : "");
                        return (
                            <div
                                key={index}
                                className={`group h-72 w-full rounded-xl [perspective:1000px] hover:scale-105 transition-transform duration-500 ${curvedClass} overflow-hidden`}>
                                <div
                                    className={`p-6 relative h-full w-full rounded-xl shadow-[0px_0px_7px_4px_rgba(171,198,248,0.5)] transition-all duration-700 [transform-style:preserve-3d] group-hover:[transform:rotateX(-180deg)] ${curvedClass}`}>
                                    <div
                                        className="p-6 absolute inset-0 [backface-visibility:hidden] bg-white rounded-xl flex flex-col items-center text-center">
                                        <div className="p-6">
                                            <img className="w-20 h-20w-20 lg:w-20 lg:h-20" src={pointDetails.path} alt={pointDetails.name} />
                                        </div>
                                        <h3 className="mt-4 text-black text-2xl sm:text-3xl lg:text-2xl font-semibold">{pointDetails.name}</h3>
                                    </div>
                                    <div
                                        className="absolute inset-0 [backface-visibility:hidden] bg-white rounded-xl flex flex-col items-center justify-center text-center [transform:rotateX(-180deg)] p-4">
                                        <h4 className="text-2xl font-semibold text-black">{pointDetails.name}</h4>
                                        <p className="mt-2 text-gray-600">{pointDetails.description}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default SquareCard;